export default "/static/images/claim-popup/3.png"